import { useMemo } from "react";
import { Row, Col } from "reactstrap";
import Widget from "../../../components/Widget";

const StatsCards = ({ stats = {}, t, isFetching }) => {
  const widgetsList = useMemo(() => {
    const total = Number(stats?.total || 0);
    const inProgress = Number(stats?.in_progress || 0);
    const completed = Number(stats?.completed || 0);
    const approved = Number(stats?.approved || 0);

    return [
      {
        amount: total,
        percent: 100,
        title: t("Total"),
        icon: "ri-stack-line",
        displayChart: false,
      },
      {
        amount: inProgress,
        title: t("In Progress"),
        icon: null,
        chart: {
          show: true,
          percent: total > 0 ? Math.round((inProgress / total) * 100) : 0,
        },
      },
      {
        amount: completed,
        title: t("Completed"),
        icon: null,
        chart: {
          show: true,
          percent: total > 0 ? Math.round((completed / total) * 100) : 0,
        },
      },
      {
        amount: approved,
        title: t("Approved"),
        icon: null,
        chart: {
          show: true,
          percent: total > 0 ? Math.round((approved / total) * 100) : 0,
        },
      },
    ];
  }, [stats, t]);

  if (isFetching) {
    return (
      <Row>
        {[1, 2, 3, 4].map((item) => (
          <Col lg="3" md="6" sm="12" key={item}>
            <div
              className="dt-field dt-skeleton"
              style={{ width: "100%", height: "120px" }}
            />
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <Row>
      {widgetsList.map((widgetData, index) => (
        <Col lg={3} md={6} sm={12} key={index}>
          <Widget {...widgetData} />
        </Col>
      ))}
    </Row>
  );
};

export default StatsCards;
